import { Input } from '@/components/ui/input'
import { useSearchParams } from 'react-router-dom'
import { useState } from 'react'
import useDebounce from '@/@diffrag/hooks/useDebounce'
import { Icon } from './Icon'

type Props = {
  searchParamKey?: string
  placeholder?: string
}

export const SearchBar = ({ searchParamKey, placeholder }: Props) => {
  const [searchParams] = useSearchParams()
  const [search, setSearch] = useState(searchParams.get('q') || '')
  useDebounce(search, {
    delay: 300,
    searchParamKey: searchParamKey || 'q',
  })

  return (
    <div className="min-w-0">
      <div className="w-[400px] max-w-full">
        <div className="relative">
          <Icon
            name="search"
            className="absolute left-2 top-1/2 -translate-y-1/2 size-4 text-muted-foreground"
          />
          <Input
            className="min-w-0 indent-6"
            placeholder={placeholder || '검색'}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>
    </div>
  )
}
